import React, { useEffect, useState } from 'react'
import styles from './ProductList/plist.module.css'

function Card(props) {
    const  [hover, setHover]=useState(false);
 
        return (
        <>
            <div>
                <div style={{ display: 'flex', margin: '2%' }}>
                    <div className={styles.card} style={{ backgroundImage: `url(${props.cardImage})`, filter: `brightness(${hover ? '50%' : '100%'})`, transition: 'filter 0.3s ease',}} onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}>
                        {/* <img src={props.image} alt="" /> */}
                        <div className={styles.overlaycard} style={{ backgroundImage: `url(${props.overlayImage})`, }}>
                        {props.customize ? (<div className={styles.customize}>
                                <h3>Customize</h3>
                            </div>) : null}
                        </div>
                    </div>
                </div>
                <div className={styles.proDetails}>
                    <h1 >{props.name}</h1> 
                    <h1 id='price'>PKR {props.price}</h1>
                </div>
            </div>
        </>
    )
}

export default Card